import { useCallback, type ReactNode } from 'react';
import { HFThemeProvider } from '@hf/designSystem/v1';
import { usePreferences, type ThemeModePref } from '@core/utils/prefs';

/**
 * Feeds user preferences into the design-system theme.
 * Before prefs load (and on the login screen) the provider stays uncontrolled on its cookie.
 */
export function ThemePrefsProvider({ children }: { children: ReactNode }) {
  const { prefs, prefsReady, updatePrefs } = usePreferences();

  const handleModeChange = useCallback(
    (themeMode: ThemeModePref) => {
      if (!prefsReady) return;
      void updatePrefs({ themeMode });
    },
    [prefsReady, updatePrefs],
  );

  return (
    <HFThemeProvider mode={prefsReady && prefs ? prefs.themeMode : undefined} onModeChange={handleModeChange}>
      {children}
    </HFThemeProvider>
  );
}
